import React from "react"
import { chakra, Box, Heading } from "@chakra-ui/react"
import PropTypes from "prop-types"
import dayjs from "dayjs"
import { mainImage } from "../domain/boat"

const getTotalPrice = (offer, search) => {
  const to = dayjs(search.checkout)
  const from = dayjs(search.checkin)
  const searchDatesPresent = search.checkin && search.checkin !== "" && search.checkout && search.checkout

  const numberOfWeeks = searchDatesPresent ? to.diff(from, "week") : 1

  return `€${numberOfWeeks * offer.discountedPrice}`
}
const SelectedBoat = ({ boat, offer, search }) => {
  const searchDatesPresent = search.checkin && search.checkin !== "" && search.checkout && search.checkout

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: ["1fr", "1fr 1fr"],
        gridAutoRows: "min-content",
        gridRowGap: [3],

        "span.title": {
          display: "block",
          color: "primary",
          fontWeight: "bold",
          textTransform: "uppercase",
        },
      }}
    >
      <Heading as="h3" variant="h3" mb={8} sx={{ gridColumn: ["1 / -1"] }}>
        Summary
      </Heading>
      <chakra.img
        mb={4}
        sx={{
          gridColumn: ["1 / -1"],
          justifySelf: ["start"],
          maxWidth: ["80%"],
        }}
        src={mainImage(boat)}
        alt="Selected Boat"
      />
      <div>
        <span className="title">Selected Boat</span>
        <span>{boat.modelName}</span>
      </div>
      <div>
        <span className="title">Name</span>
        <span>{boat.name}</span>
      </div>
      {searchDatesPresent && (
        <>
          <div>
            <span className="title">Check-in Date</span>
            <span>{dayjs(search.checkin).format("DD MMMM YYYY")}</span>
          </div>
          <div>
            <span className="title">Check-out Date</span>
            <span>{dayjs(search.checkout).format("DD MMMM YYYY")}</span>
          </div>
        </>
      )}
      {offer && (
        <>
          <div>
            <span className="title">Total Price</span>
            <span>{getTotalPrice(offer, search)}</span>
          </div>
          <div>
            <span className="title">Starting Port</span>
            <span>{offer.startBase.name}</span>
          </div>
        </>
      )}
    </Box>
  )
}

SelectedBoat.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  boat: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  offer: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  search: PropTypes.object.isRequired,
}

export default SelectedBoat
